import React from 'react';
import '../App.css';

export default function RolunkPage() {
  return (
    <main>
      <section className="section faq-full">
        <h2>Rólunk</h2>
        <p>
          A Move and Parcel csapata megbízható, szakmailag magas színvonalú szállítási és
          költöztetési megoldásokat nyújt – egyedi igényekre szabva, belföldön és nemzetközi
          viszonylatban egyaránt.
        </p>
        <p>
          Ez az oldal hamarosan bővebben bemutatja történetünket, értékeinket és azt, hogyan dolgozunk
          az ügyfeleinkkel. Addig is bátran keressen minket elérhetőségeinken vagy kérjen árajánlatot.
        </p>
      </section>
    </main>
  );
}
